import React from "react";
import { Box, IconButton, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";

import { makeStyles, useTheme } from "../../theme/Theme";
import { AppLayoutContent } from "../../components/app-layout/AppLayoutContent";
import { DocumentsPageHeader } from "../../components/documents/DocumentsPageHeader";
import { downloadFile } from "../../utils";
import { DownloadIcon } from "../../components/icons/DownloadIcon";
import { useStateParams } from "../../hooks/useStateParams";
import { AppRoutes } from "../../constants/AppRoutes";

export interface AgreementPageParams {
  title: string;
  text: string;
  link: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    paddingLeft: 0,
    paddingRight: 0,
  },
  top: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  content: {
    flex: 1,
  },
  title: {
    color: theme.palette.total.main,
  },
}));

export function AgreementPage() {
  const navigate = useNavigate();
  const styles = useStyles();
  const theme = useTheme();

  const [link] = useStateParams<string>("", "link", undefined, (link) => link);
  const [title] = useStateParams<string>("", "title", undefined, (link) => link);

  const backHandler = () => {
    if (window.history.state.idx > 1) {
      navigate(-1);
    } else {
      navigate(AppRoutes.StartAuth);
    }
  };

  const downloadPdf = (url: string) => {
    downloadFile(url);
  };
  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: theme.palette.arctic.main,
      }}
      direction="column"
      flexGrow={1}
    >
      <Stack
        direction="column"
        sx={{
          paddingX: { xs: "16px", sm: "16px", md: "0px", lg: "0px" },
          maxWidth: "1280px",
          width: "100%",
          paddingTop: { xs: "14px", sm: "20px", md: "32px" },
          backgroundColor: "arctic.main",
          zIndex: 100,
          transform: "translateX(-4px)",
          paddingLeft: "4px",
        }}
      >
        <DocumentsPageHeader onBack={backHandler} />
        <div className={styles.top}>
          <Typography variant={"h1"} className={styles.title}>
            {title}
          </Typography>
          <IconButton onClick={() => downloadPdf(link)}>
            <DownloadIcon />
          </IconButton>
        </div>
      </Stack>

      <AppLayoutContent className={styles.root}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            paddingTop: {
              xs: "24px",
              md: "32px",
            },
            paddingBottom: {
              xs: "0px",
              md: "12px",
            },
            height: "100%",
          }}
        >
          <iframe
            src={link}
            width="100%"
            height="100%"
            className={styles.content}
            title={title || "Agreement"}
          />
        </Box>
      </AppLayoutContent>
    </Stack>
  );
}
